import React from 'react';

import ButtonComponent from '../../../../common/genericComponents/redesign/buttonComponent/buttonComponent';
import Spinner from '../../../../common/genericComponents/spinner';

import './anMeetingBottomActionButtons.css';

const AnMeetingBottomActionButtons = ({
  showLeftBtn = false,
  showRightBtn = false,
  showSpinner = false,
  leftBtnTxt = '',
  rightBtnTxt = '',
  leftBtnFunc = () => {},
  rightBtnFunc = () => {},
}) => {
  return (
    <div
      className={`et-an-anonymous-buttons-container  ${
        !showRightBtn ? 'et-an-anonymous-buttons-align-end' : ''
      }`}>
      {showLeftBtn && (
        <div className="et-an-anonymous-primary-outlined-btn">
          <ButtonComponent
            type="primary-outlined"
            isDisabled={false}
            onClick={leftBtnFunc}
            text={leftBtnTxt}
          />
        </div>
      )}
      {showRightBtn && (
        <div className="et-an-anonymous-primary-btn et-n-anonymous-bow-spinner et-n-white-bg-spinner">
          <ButtonComponent
            type="primary"
            isDisabled={false}
            onClick={rightBtnFunc}
            text={showSpinner ? null : rightBtnTxt}
            image={showSpinner ? <Spinner /> : null}
          />
        </div>
      )}
    </div>
  );
};

export default AnMeetingBottomActionButtons;
